<form [formGroup]="form">
  <div class="gap-lg grid" formArrayName="ressources">
    @for (ressource of ressources.controls; track $index; let idx = $index) {
      <app-ressource-form-item [form]="ressource" [idx]="idx" [productions]="productions()"></app-ressource-form-item>
    }
    <app-button-add-new (click)="addRessource()" label="Ajouter une autre ressource professionnelle" />
  </div>
</form>
